<template>

  <div class="height-100">
    <Unavailable
      v-if="unavailable"
      title="Questionários e testes"
      class="height-100" />

    <div
      v-if="!unavailable"
      class="vflex">
      <div class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <h4>{{ $t('Questionnaires/Tests') }}</h4>
          </div>
          <div class="btn-row">
            <div class="form-inline">
              <input-keyword
                @input="setKeywords"
                :placeholder="$t('Search')"
                class="mr-2" />
              <button
                type="button"
                class="btn btn-primary"
                @click="showCreateModal()">
                + {{ $t('New questionnaire') }}
                </button>
            </div>
          </div>
        </div>
      </div>

      <div class="vflex-row-1">
        
        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="loadData">
          
          <template slot="content">
            <table class="table">
              <thead>
                <tr>
                  <th-sort
                    field="name"
                    :value="sort"
                    @input="setSort">{{ $t('Name') }}</th-sort>
                  <th-sort
                    field="type"
                    :value="sort"
                    @input="setSort">{{ $t('Type') }}</th-sort>
                  <th-sort
                    field="created_at"
                    :value="sort"
                    @input="setSort">{{ $t('Created at') }}</th-sort>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in questionforms"
                  :key="index">
                  <td class="text-truncate">
                    <a href="javascript:void(0)" @click="showEditModal(item)" v-if="item.fixed !== true">{{ item.name }}</a>
                    <span v-if="item.fixed === true">{{ item.name }}</span>
                  </td>
                  <td class="text-truncate">{{ {'quiz': 'Questionário', 'test': 'Teste'}[item.type] }}</td>
                  <td class="text-truncate">{{ $d(new Date(item.created_at), 'short') }}</td>
                </tr>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

        <questionform-form 
          v-if="modal_select"
          :initQuestionform="modal_select" 
          @hideModal="hideModal ()" 
          @deleted="loadData(); hideModal()" 
          @saved="loadData(paginate.page); hideModal()">
          </questionform-form>

      </div>
    </div>
  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import QuestionformForm from './QuestionformForm'
import Paginaty from '@/components/Paginaty/Paginaty'
import Unavailable from '../Unavailable/Unavailable'

export default {
  name: 'Questionform',
  components: {
    QuestionformForm,
    ThSort,
    InputKeyword,
    Paginaty,
    Unavailable
  },
  data () {
    return {
      unavailable: false,
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name'
    }
  },
  computed: {
    questionforms () {
      return this.$store.getters.getQuestionforms
    },
    paginate () {
      return this.$store.getters.getQuestionformsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /* loadData  */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectQuestionforms', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      }).catch(err => {
        this.unavailable = err.response && err.response.data && err.response.data.name === 'UpgradeRequired'
      })
    },
    /* filters  */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /* modal  */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Questionform/Questionform.vue